import {Model} from 'vue-mc';
//import { boolean , equal , integer , min , required , string , and , length , alphanumeric } from 'vue-mc/validation';

export class PerfilModel extends Model{
  // Default attributes that define the "empty" state.
  defaults() {
    return {
      id: null
      , groupName: ""
      , descripcion: ""
      , estatus: "A"
    }
  }

  // Attribute mutations.
  mutations() {
    return {
        id:id=>id
      , group_name:group_name=>group_name
      , descripcion:descripcion=>descripcion
      , estatus:estatus=>estatus          
    }
  }

  // Attribute validation
  validation() {
    return {
    }
  }

  // Model Options
  options() {
    return {
      validateOnSave     : false
      , validateOnChange   : false 
      , validateRecursively: false
    }
  }

}


// WEBPACK FOOTER //
// ./src/models/seguridad/perfil.js